import ResponsiveImage from '@/components/ResponsiveImage'
import Link from 'next/link'
import { memo } from 'react'

const lineItemImgLoader = ({ src }) => {
  return `${src}?w=400`
}

const LineItemProductImage = ({
  imageUrl,
  title,
  productUrl,
  isGiftOrder,
  isSubscriptionBox,
  isBabProduct,
}) => {
  const shouldPreventLinkNavigation = (isSubscriptionBox && !isGiftOrder) || isBabProduct
  return (
    <Link
      className={`order-item__image ${shouldPreventLinkNavigation ? 'image--subscription-box' : ''}`}
      href={productUrl}
      onClick={(e) => {
        if (shouldPreventLinkNavigation) {
          e.preventDefault()
        }
      }}
    >
      <ResponsiveImage
        loader={lineItemImgLoader}
        src={imageUrl}
        alt={title}
        isGiftOrder={isGiftOrder}
      />
    </Link>
  )
}

export default memo(LineItemProductImage)
